/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BaseSelect from 'shared/ui/components/form-components/BaseSelect.vue';
import RadioButtons from 'shared/ui/components/form-components/RadioButtons.vue';

const __vue_script__ = {
    name: 'AnonymizeAllOrByDomain',

    components: { BaseSelect, RadioButtons },

    props: {
        value: {
            type: Array,
            required: false,
            default: () => [],
        }
    },

    data() {
        return {
            /** @type {{value:string,label:string}[]} */
            anonymizeAllOrByDomainOptions: [
                { value: 'all', label: this.t('anonymize_all_users') },
                { value: 'by-domain', label: this.t('anonymization_domains') },
            ],
            /** @type {'all'|'by-domain'} */
            anonymizeAllOrByDomain: 'all',
            /** @type {{value:string,label:string}[]} */
            anonymizationDomainChoices: [],
            /** @type {{value:string,label:string}[]} */
            anonymizationDomainOptions: [],
        };
    },

    created() {
        if (Array.isArray(this.value) && this.value.length) {
            this.anonymizationDomainChoices = this.value.map(d => ({ value: d, label: d }));
            this.anonymizeAllOrByDomain = 'by-domain';
        }
    },

    methods: {
        /** @param {string[]|undefined} value */
        emit(value) {
            this.$emit('input', value);
        },

        /** @param {string} key */
        t(key) {
            return this.$i18n.t(`wizards.create_workspace.form.${key}`).toString();
        },

        /** @param {string} domain */
        addAnonymizationDomain(domain) {
            this.anonymizationDomainChoices.push({ value: domain, label: domain });
            this.anonymizationDomainOptions.push({ value: domain, label: domain });
            this.emit(this.anonymizationDomainChoices.map(d => d.value));
        },

        /** @param {{value:string,label:string}[]}  data */
        onDomainsChange(data) {
            this.anonymizationDomainChoices = data;
            this.emit(this.anonymizationDomainChoices.map(d => d.value));
        },

        /** @param {boolean} anonymization */
        onAnonymizationChange(anonymization) {
            this.emit(
                anonymization
                    ? this.anonymizationDomainChoices.map(d => d.value)
                    : undefined
            );
        },

        /** @param {'all'|'by-domain'} type */
        onAnonymizeAllOrByDomainChange(type) {
            this.emit(
                type === 'by-domain'
                    ? this.anonymizationDomainChoices.map(d => d.value)
                    : undefined
            );
        },
    },
};


/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "anonymize-all-or-by-domain feature-dependant" },
    [
      _c("radio-buttons", {
        attrs: {
          name: "visibility",
          options: _vm.anonymizeAllOrByDomainOptions,
        },
        on: { input: _vm.onAnonymizeAllOrByDomainChange },
        model: {
          value: _vm.anonymizeAllOrByDomain,
          callback: function ($$v) {
            _vm.anonymizeAllOrByDomain = $$v
          },
          expression: "anonymizeAllOrByDomain",
        },
      }),
      _vm.anonymizeAllOrByDomain === "by-domain"
        ? _c("base-select", {
            ref: "domainPicker",
            staticClass: "feature-dependant",
            attrs: {
              name: "anonymization_domains_picker",
              "track-by": "value",
              value: _vm.anonymizationDomainChoices,
              multiple: true,
              options: _vm.anonymizationDomainOptions,
              placeholder: _vm.t("anonymization_domains_placeholder"),
              taggable: true,
            },
            on: { input: _vm.onDomainsChange, tag: _vm.addAnonymizationDomain },
          })
        : _vm._e(),
    ],
    1
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/backstage/src/ui/components/AnonymizeAllOrByDomain.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__